import { reducer as userSessionReducer } from "@talentech/bff-login";
import { combineReducers } from "redux";
import { pagesApi } from "./pages.api";
import { faviconsApi } from "./favicons.api";
import { navigationApi } from "./navigation.api";
import { mediaApi } from "./media.api";
import { customersApi } from "./customers.api";
import { fontsApi } from './fonts.api';
import { directJobsApi } from "./directJobs.api";

const reducer = combineReducers({
  userSession: userSessionReducer,
  [pagesApi.reducerPath]: pagesApi.reducer,
  [faviconsApi.reducerPath]: faviconsApi.reducer,
  [navigationApi.reducerPath]: navigationApi.reducer,
  [mediaApi.reducerPath]: mediaApi.reducer,
  [customersApi.reducerPath]: customersApi.reducer,
  [fontsApi.reducerPath]: fontsApi.reducer,
  [directJobsApi.reducerPath]: directJobsApi.reducer,
});

export default reducer;
